// extracted by mini-css-extract-plugin
export default {"modalOverlay":"AdminCanvasSidebar_modalOverlay__h0oO0","modalContainer":"AdminCanvasSidebar_modalContainer__OXdbk","closeButton":"AdminCanvasSidebar_closeButton__M0bXe"};